import './UIButtonGroup.scss';

import * as React from 'react';

import cx from 'classnames';

import { ButtonProps } from './UIButton';

const ButtonDivider: React.FC = () => {
  return <div className="sm:w-px h-12 sm:bg-divider" />;
};

interface ButtonGroupProps {
  className?: string;
  /** This value will be applied to child buttons. */
  appearance: ButtonProps['appearance'];
  orientation: string;
}

/**
 * Wraps UIButton children in a div and applies dividing borders between.
 * Currently, this is only intended for use with `text` style
 * button components.
 */
export class UIButtonGroup extends React.Component<ButtonGroupProps> {
  public static defaultProps = {
    appearance: 'text',
    orientation: 'horizontal',
  };

  constructor(props: ButtonGroupProps) {
    super(props);
  }

  renderChildButtons(children, appearance) {
    return children.map((child, index, array) => {
      const isFirst = index === 0;

      if (child.props.type === 'button') {
        const isLast = index === array.length - 1;
        const roundedClassName = cx('rounded-2', {
          'sm:rounded-tr-0 sm:rounded-br-0': isFirst && !isLast,
          'sm:rounded-tl-0 sm:rounded-bl-0': isLast && !isFirst,
          'sm:rounded-0': !isFirst && !isLast,
        });

        return [
          !isFirst && <ButtonDivider key={index} />,
          React.cloneElement(child, { appearance, roundedClassName }),
        ];
      } else {
        return [!isFirst && <ButtonDivider key={index} />, child];
      }
    });
  }

  render() {
    const { children, className, appearance } = this.props;
    const groupClass = cx(
      'flex items-center font-display text-display font-500 ui-button-group',
      {
        [className as string]: !!className,
      }
    );

    return (
      <div className={groupClass}>
        {this.renderChildButtons(children, appearance)}
      </div>
    );
  }
}
